<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Callcentre",
  path: "call-centre",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
